import { UserAccessControlPolicy } from '#User/acl/User.ACL'
import { UsersRoutingService } from '#User/routing'
import { UserService } from '#User/services'
import { useUserStore } from '#User/store'

export const useUser = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(UserService)
    },
    get acl() {
      return alt.get(UserAccessControlPolicy)
    },
    get routing() {
      return alt.get(UsersRoutingService)
    },
    get store() {
      return useUserStore()
    },
  }
}
